import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4407b6e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "booking-stepper" }
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", null, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step) => {
            return (_openBlock(), _createElementBlock("li", {
              key: step,
              class: _normalizeClass({complete: _ctx.completedSteps.includes(step), 'active': step.number === _ctx.currentStep.number })
            }, [
              _createVNode(_component_BaseButton, {
                onClick: ($event: any) => (_ctx.goToStep(step.number))
              }, null, 8, ["onClick"])
            ], 2))
          }), 128))
        ]),
        _createElementVNode("span", null, _toDisplayString(_ctx.currentStep.number) + ". " + _toDisplayString(_ctx.currentStep.name), 1)
      ])
    ])
  ]))
}